import { Action } from "../../../actions/actions";
import { PresetsActionTypes } from "../actions/actionTypes";
import { Subsidiary } from "../../halls/types/subsidiaries";

export function subsidiariesList(state: Subsidiary[] = [], action: Action) {
    switch (action.type) {
        case PresetsActionTypes.GET_SUBSIDIARIES_SUCCESS:
            return action.payload.subsidiaries.results;
        default:
            return state;
    }
}

export function subsidiariesLoading(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case PresetsActionTypes.GET_SUBSIDIARIES:
            return true;
        case PresetsActionTypes.GET_SUBSIDIARIES_SUCCESS:
        case PresetsActionTypes.GET_SUBSIDIARIES_FAIL:
            return false;
        default:
            return state;
    }
}
